import { createContext, useCallback, useContext, useState } from "react";

const BookCallCtx = createContext(null);

export function BookCallProvider({ children }) {
    const [open, setOpen] = useState(false);
    const [context, setContext] = useState({ source: "book-a-call", use_case_id: null });

    const openModal = useCallback((ctx = {}) => {
        setContext({ source: "book-a-call", use_case_id: null, ...ctx });
        setOpen(true);
    }, []);

    const closeModal = useCallback(() => setOpen(false), []);

    return (
        <BookCallCtx.Provider value={{ open, openModal, closeModal, context }}>
            {children}
        </BookCallCtx.Provider>
    );
}

export function useBookCall() {
    const ctx = useContext(BookCallCtx);
    if (!ctx) throw new Error("useBookCall must be used within BookCallProvider");
    return ctx;
}
